import { EmailSvgIcon, FacebookFlatSvgIcon, InstagramSvgIcon, TwitterSvgIcon } from './images'
import styles from './page-footer.module.scss'
import React from 'react'
import { Link } from 'react-router-dom'

export const PageFooter = (): React.ReactElement => {
  return (
    <footer className={styles.footer}>
      <div className={styles.iconsRow}>
        <FooterSocialLink href="https://www.facebook.com/groups/1516167752096283" title="Facebook" Icon={FacebookFlatSvgIcon} />
        <FooterSocialLink href="https://www.instagram.com/grndhouseapp/" title="Instagram" Icon={InstagramSvgIcon} />
        <FooterSocialLink href="https://twitter.com/grndhouseapp" title="Twitter (X)" Icon={TwitterSvgIcon} />
        <FooterSocialLink href="mailto:support@grndhouse.com" title="Email" Icon={EmailSvgIcon} />
      </div>
      <div className={styles.copyrightRow}>
        <span className={styles.copyright}>
          Copyright © {new Date().getFullYear()} Hurricane Labs Limited. All rights reserved.
        </span>
      </div>
      <div className={styles.linksRow}>
        <Link to="/privacy-policy" className={styles.footerLink}>
          Privacy Policy
        </Link>
        <Link to="/terms-conditions" className={styles.footerLink}>
          Terms & Conditions
        </Link>
      </div>
    </footer>
  )
}

const FooterSocialLink = ({
  href,
  title,
  Icon,
}: {
  href: string
  title: string
  Icon: React.ComponentType<{ className?: string }>
}): React.ReactElement => {
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" title={title} className={styles.iconLink}>
      <Icon className={styles.icon} />
    </a>
  )
}
